module.exports = __webpack_public_path__ + "static/New-32b93d5d3d892f99adf64826c19b4c5e.png";